module.exports = __webpack_public_path__ + "img/bg.64af370d.png";